import Vue from 'vue'
import Vuex from 'vuex'

import { MdField, MdApp, MdDrawer, MdToolbar, MdList, MdButton, MdCard, MdContent, MdBadge, MdDivider, MdMenu, MdCheckbox, MdSubheader, MdRadio, MdDatepicker, MdDialog, MdSnackbar, MdProgress, MdSpeedDial } from 'vue-material/dist/components'
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'

import (/* webpackChunkName: "styles" */"../components/custom.scss");

Vue.use(Vuex)
Vue.use(MdField)
Vue.use(MdApp)
Vue.use(MdDrawer)
Vue.use(MdToolbar)
Vue.use(MdList)
Vue.use(MdButton)
Vue.use(MdCard)
Vue.use(MdContent)
Vue.use(MdBadge)
Vue.use(MdDivider)
Vue.use(MdMenu)
Vue.use(MdCheckbox)
Vue.use(MdSubheader)
Vue.use(MdRadio)
Vue.use(MdDatepicker)
Vue.use(MdDialog)
Vue.use(MdSnackbar)
Vue.use(MdProgress)
Vue.use(MdSpeedDial)

Vue.material.locale.dateFormat = 'dd/MM/yyyy'
Vue.material.locale.firstDayOfAWeek = 1
Vue.material.locale.days = ['Nedjelja', 'Ponedjeljak', 'Utorak', 'Srijeda', 'Četvrtak', 'Petak', 'Subota']
Vue.material.locale.shortDays = ['Ned', 'Pon', 'Uto', 'Sri', 'Čet', 'Pet', 'Sub']
Vue.material.locale.shorterDays = ['P', 'U', 'S', 'Č', 'P', 'S', 'N']
Vue.material.locale.months = ['Januar', 'Februar', 'Mart', 'April', 'Maj', 'Juni', 'Juli', 'Avgust', 'Septembar', 'Ocktobar', 'Novembar', 'Decembar']
Vue.material.locale.shortMonths = ['Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun', 'Jul', 'Avg', 'Sep', 'Okt', 'Nov', 'Dec']
Vue.material.locale.shorterMonths = ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D']

import * as jsPDF from 'jspdf'

import createPersistedState from "vuex-persistedstate";

/*
# spremanje dokumenta
# - - - - - - - - - - 

import axios from "axios";
*/

const empty_state = {
  korak: 1,
  upozorenje: true,
  zavrseno: true,
  jezik: 'bs',
  podaci: {
    ime: null,
    email: null,
    kontakt: null,
    poruka: null,
    usluga: [],
    dizajn: null,
    platforma: null,
    dodatno: [],
    obim: null,
    finansije: null,
    saradnja: null,
    rok: null,
  }
}

export default new Vuex.Store({
  plugins: [
    createPersistedState(
      {
        key: 'koraci'
      }
    ),
  ],
  state: {
    korak: 1,
    upozorenje: true,
    zavrseno: true,
    jezik: 'bs',
    podaci: {
      ime: null,
      email: null,
      kontakt: null,
      poruka: null,
      usluga: [],
      dizajn: null,
      platforma: null,
      dodatno: [],
      obim: null,
      finansije: null,
      saradnja: null,
      rok: null,
    }
  },
  mutations: {
    korak_prvi(state) {
      state.korak = empty_state.korak
      state.upozorenje = empty_state.upozorenje
      state.zavrseno = false
    },
    upozorenje (state, upozorenje) {
      state.upozorenje = !upozorenje
    },
    zavrseno (state, zavrseno) {
      state.zavrseno = !zavrseno
    },
    jezik (state, jezik) {
      state.jezik = jezik
    },
    
    ime (state, ime) {
      state.podaci.ime = ime
    },
    email (state, email) {
      state.podaci.email = email
    },
    kontakt (state, kontakt) {
      state.podaci.kontakt = kontakt
    },
    poruka (state, poruka) {
      state.podaci.poruka = poruka
    },
    usluga (state, usluga) {
      state.podaci.usluga = usluga
    },
    dizajn (state, dizajn) {
      state.podaci.dizajn = dizajn
    },
    platforma (state, platforma) {
      state.podaci.platforma = platforma
    },
    dodatno (state, dodatno) {
      state.podaci.dodatno = dodatno
    },
    obim (state, obim) {
      state.podaci.obim = obim
    },
    finansije (state, finansije) {
      state.podaci.finansije = finansije
    },
    saradnja (state, saradnja) {
      state.podaci.saradnja = saradnja
    },
    rok (state, rok) {
      state.podaci.rok = rok
    },

    korak_nazad (state) {
      state.korak--
    },
    korak_naprijed (state) {
      state.korak++
    },
    korak_potvrda(state) {
      state.korak++  
    },
    korak_posljednji(state) {
      let ls = 45
      let ln = 7

      let datum = new Date()
      let datum_dokumenta = datum.toLocaleDateString("en-AU")
      let sat = datum.getHours()
      if (sat < 10) {
        sat = "0" + sat;
      }

      let vrijeme_dokumenta = sat+':'+datum.getMinutes()

      let ime = state.podaci.ime
      let email = state.podaci.email
      let kontakt = state.podaci.kontakt

      let usluga = state.podaci.usluga
      let dizajn = state.podaci.dizajn
      let platforma = state.podaci.platforma
      let dodatno = state.podaci.dodatno
      let opis = state.podaci.poruka
      let obim = state.podaci.obim
      let finansije = state.podaci.finansije
      let saradnja = state.podaci.saradnja
      let rok = state.podaci.rok

      let jezik = state.jezik

      let naslov_dokumenta = "Podaci formulara za "
      let dokument_generisan = "Dokument generisan: "
      let email_dokumenta = "Email adresa: "
      let kontakt_dokumenta = "Kontakt: "
      let usluga_dokumenta = "Vrsta usluge: "
      let dodatno_dokumenta = "Dodatno: "
      let dizajn_dokumenta = "Dizajn: "
      let platforma_dokumenta = "Platforma: "
      let opis_dokumenta = "Kratki opis: "

      let obim_dokumenta = "Obim projekta: "
      let finansije_dokumenta = "Finansije: "
      let saradnja_dokumenta = "Saradnja: "
      let rok_dokumenta = "Rok: "
      let naziv_dokumenta = "Formular"

      if(jezik == 'en') {
        naslov_dokumenta = "Submited form data by "
        dokument_generisan = "Document generated: "
        email_dokumenta = "Email address: "
        kontakt_dokumenta = "Contact: "
        usluga_dokumenta = "Type of service: "
        dodatno_dokumenta = "Additional: "
        dizajn_dokumenta = "Design: "
        platforma_dokumenta = "Platform: "
        opis_dokumenta = "Short descirption: "
        obim_dokumenta = "Project scope: "
        finansije_dokumenta = "Budget: "
        saradnja_dokumenta = "Cooperate: "
        rok_dokumenta = "Deadline: "
        naziv_dokumenta = "Submission"
      }
      
      let doc = new jsPDF({
        orientation: 'p',
        unit: 'mm',
        format: 'a4',
        putOnlyUsedFonts:true
      })
      
      doc.setFont('helvetica', 'normal')

      doc.setFontSize(13)
      doc.setDrawColor(150,150,150);
      
      doc.cell(10, 10, 188, 20, naslov_dokumenta+ime.replace('đ','dj').replace('č','c').replace('ć','c'));
      
      doc.setFontSize(10)
      doc.cell(10, 262, 188, 20, dokument_generisan+datum_dokumenta+" @ "+vrijeme_dokumenta+"h");

      doc.setFontSize(13)
      // email
      doc.text(email_dokumenta + email, 10, ls)
      ls = ls+ln
      // nacin
      doc.text(kontakt_dokumenta + kontakt, 10, ls)
      ls = ls+(ln*2)
      // usluga
      doc.text(usluga_dokumenta, 10, ls)
      ls = ls+ln
      for (let i = 0; i < usluga.length; i++) { 
        doc.text('- '+usluga[i], 10, ls)
        ls = ls+ln
      }
      ls = ls+ln
      // dodatno
      doc.text(dodatno_dokumenta, 10, ls)
      ls = ls+ln
      for (let i = 0; i < dodatno.length; i++) { 
        doc.text('- '+dodatno[i], 10, ls)
        ls = ls+ln
      }
      ls = ls+ln
      // dizajn
      doc.text(dizajn_dokumenta + dizajn, 10, ls)
      ls = ls+ln
      // platforma
      doc.text(platforma_dokumenta + platforma, 10, ls)
      ls = ls+(ln*2)
      // opis
      doc.text(opis_dokumenta.replace('đ','dj').replace('č','c').replace('ć','c'), 10, ls)
      ls = ls+ln
      doc.text(opis, 10, ls)
      ls = ls+(ln*2)
      // obim
      doc.text(obim_dokumenta + obim, 10, ls)
      ls = ls+ln
      // finansije
      doc.text(finansije_dokumenta + finansije, 10, ls)
      ls = ls+ln
      // saradnja
      doc.text(saradnja_dokumenta + saradnja, 10, ls)
      ls = ls+ln
      // rok
      doc.text(rok_dokumenta + rok, 10, ls)
      ls = ls+ln
      doc.setProperties({
        title: naziv_dokumenta+'-'+datum_dokumenta.replace(/\//g,'-'),
        subject: 'Generisani PDF dokument',		
        author: 'Programerska radionica DIGITAL',
        keywords: 'generated, javascript, vue',
        creator: 'Vahid Smajlagic'
      });
      doc.save(naziv_dokumenta+'-'+datum_dokumenta.replace(/\//g,'-')+'.pdf')

      /*
      # spremanje dokumenta
      # - - - - - - - - - - 

      axios.get("_dokument.php")
        .then(response => 
          console.log(response.status)
        )
      */

      state.korak = 1
      state.zavrseno = true
      state.podaci = empty_state.podaci
    }
  },
  actions: {
    naprijed ({ commit }) {
      commit('korak_naprijed')
    },
    nazad ({ commit }) {
      commit('korak_nazad')
    },
    potvrdi ({ commit }) {
      commit('korak_potvrda')
    },
    zavrsi ({ commit }) {
      commit('korak_posljednji')
    },
    pocni ({ commit }) {
      commit('korak_prvi')
    }
  },
  getters: {
    ime: state => {
      return state.podaci.ime
    },
    email: state => {
      return state.podaci.email
    },
    kontakt: state => {
      return state.podaci.kontakt
    },
    poruka: state => {
      return state.podaci.poruka
    },
    usluga: state => {
      return state.podaci.usluga
    },
    dizajn: state => {
      return state.podaci.dizajn
    },
    platforma: state => {
      return state.podaci.platforma
    },
    dodatno: state => {
      return state.podaci.dodatno
    },
    obim: state => {
      return state.podaci.obim
    },
    finansije: state => {
      return state.podaci.finansije
    },
    saradnja: state => {
      return state.podaci.saradnja
    },
    rok: state => {
      return state.podaci.rok
    }
  }
})

